module.exports = __webpack_public_path__ + "static/media/multisys-logo.ee682c7e.png";